import { render } from "./Approved.vue?vue&type=template&id=2c94dfac&scoped=true"
import script from "./Approved.vue?vue&type=script&lang=js"
export * from "./Approved.vue?vue&type=script&lang=js"

import "./Approved.vue?vue&type=style&index=0&id=2c94dfac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c94dfac"]])

export default __exports__